import { usePrevious } from '@ps/web-shared-components';
import { useEffect } from 'react';

const useTableSelectFirstRow = ({
  firstRowId,
  selectedRowId,
  setSelectedTournamentId
}: {
  firstRowId?: number;
  selectedRowId?: number;
  setSelectedTournamentId?: (id: number) => void;
}) => {
  const prevSelectedRowId = usePrevious(selectedRowId || 0);
  const prevFirstRowId = usePrevious(firstRowId || 0);

  useEffect(() => {
    if (!setSelectedTournamentId) return;
    if (!firstRowId) return;
    if ((!selectedRowId && !prevSelectedRowId) || firstRowId !== prevFirstRowId)
      setSelectedTournamentId(firstRowId);
  }, [firstRowId, selectedRowId, setSelectedTournamentId, prevSelectedRowId, prevFirstRowId]);
};

export default useTableSelectFirstRow;
